import { ENDPOINTS } from '@/settings/endpoints';

export interface CourseData {
  title: string;
  cleanTitle: string;
  link: string;
}

export class FlowpressService {
  static async getCoursesList(): Promise<CourseData[]> {
    try {
      const response = await fetch(`${ENDPOINTS.flowpress}/faculdade-courses-list/`);
      const json = await response.json();

      return json?.courses || [];
    } catch (error) {
      return [];
    }
  }
}
